export default {"src":"/_next/static/media/github-slateus.3d2141cf.svg","height":100,"width":100};